<!-- <div id="cookieConsent" class="alert alert-info alert-dismissible show cManikcookie" role="alert">
    Use this space to summarize your privacy and cookie use policy. <a asp-area="" asp-controller="Home"
        asp-action="Privacy">Learn More</a>.
    <button type="button" class="accept-policy close" data-dismiss="alert" aria-label="Close"
        (click)="ManikCookiePolicy();">
        <span aria-hidden="true">Accept</span>
    </button>
</div> -->
<router-outlet></router-outlet>